var _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashDepositDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 157,
    viewBox: "0 0 216 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.831,
    cy: 121.324,
    r: 68,
    transform: "rotate(65.4517 117.831 121.324)",
    fill: "#B3E5FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.831,
    cy: 121.324,
    r: 68,
    transform: "rotate(65.4517 117.831 121.324)",
    fill: "#9977BB"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.653,
    cy: 51.0333,
    r: 117,
    transform: "rotate(65.4517 40.653 51.0333)",
    fill: "#2B195B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.653,
    cy: 51.0333,
    r: 117,
    transform: "rotate(65.4517 40.653 51.0333)",
    fill: "#FFCDD2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashDepositDesign);
export default __webpack_public_path__ + "static/media/cash_deposit_design.3c56d9b092f344e1ea66f5dbed23e7b1.svg";
export { ForwardRef as ReactComponent };